import { Injectable } from '@angular/core';
import {EntityState, EntityStore, QueryEntity, StoreConfig} from '@datorama/akita';
import {ManufacturingItemSaveModel} from "web-shared";

interface ItemAutoSaveState extends EntityState<ManufacturingItemSaveModel> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({name: 'item-auto-save', idKey: 'Id'})
export class ItemAutoSaveStore extends EntityStore<ItemAutoSaveState> {

  constructor() {
    super();
  }

}

@Injectable({
  providedIn: 'root'
})
export class ItemAutoSaveQuery extends QueryEntity<ItemAutoSaveState, ManufacturingItemSaveModel> {
  constructor(protected store: ItemAutoSaveStore) {
    super(store);
  }

  getAll$ = this.selectAll();
}
